module.exports = __webpack_public_path__ + "img/autosense-product-page-mock.38b74d51.png";